import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import ChatFooterSendButton from './ChatFooterSendButton';
import ChatFooterEmojiButton from './ChatFooterEmojiButton';
import ChatFooterUploadButton from './ChatFooterUploadButton';
import EmojiContainer from './EmojiContainer';
import ellipsis from '/chat/src/common/js/lib/ellipsis';
import Spinner from '/chat/src/components/Spinners/FountainDrops'
import {Twemoji} from 'react-emoji-render';
import { backendApiUrl } from "/chat/src/ENV";

import style from './style.scss';
import {TicketModel, CustomizationModel} from '/chat/src/redux/model'


class ChatFooter extends Component {
    constructor(){
        super()
        this._handleChange = this._handleChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.focusTimeout = null;
        this.addEmoji = this.addEmoji.bind(this);
        this.handleTextareaInput = this.handleTextareaInput.bind(this);
        this.handleTextareaKeypress = this.handleTextareaKeypress.bind(this);
        this.state =  {
            filename: '',
            filetype: null,
            blob: null,
            fileIsUploading: false,
            size: null,
            value: ''
        }
    }

    componentDidMount(){
        this.focusTimeout = setTimeout(() => {
            this.chatTextareaDOM.focus();
        }, );
    }

    componentWillUnmount(){
        clearTimeout(this.focusTimeout);
    }
    componentDidUpdate(){
        if(this.chatTextareaDOM) this.chatTextareaDOM.focus();
    }

    /**
     * The selected emoji is placed in the text, in the position of the caret.
     *
     * This causes React to update the DOM and the caret position will be moved to 0.
     * To counter this, this code manually moves the caret to the correct position
     * @param {*} emoji
     */
    addEmoji(emoji){
        const caretPosStart = this.chatTextareaDOM.selectionStart
        // Insert emoji into the text
        const text = this.state.value
        const value = text.slice(0, caretPosStart) + emoji + text.slice(caretPosStart)
        // Restore the caret position after updating the text field
        this.setState({ value: value }, () => {
            this.chatTextareaDOM.setSelectionRange(caretPosStart+2, caretPosStart+2);
          });
    }

    handleTextareaKeypress(e){
        //  enter key
        if(e.keyCode === 13 && e.shiftKey === false){
            if(!this.props.room){
                this.sendMessage()
            }else{
                if(e.altKey === true){
                    this.setState({value: e.target.value+'\r\n'})
                }else{
                    this.sendMessage()
                }
            }
            e.preventDefault();
        }
    }
    handleTextareaInput(e){
        this.setState({value: e.target.value})
        if(!this.props.room) return;
        this.props.dispatch(TicketModel.socketSendIamTyping(this.props.room))
    }

    sendMessage(){
        this.uploadFile()
        this.props.dispatch(TicketModel.socketSendTextEntry(this.state.value, this.props.room))
        this.setState({value: ''})
    }
//============================= HANDLE FILES =================================
    humanFileSize(bytes, si) {
        var thresh = si ? 1000 : 1024;
        if(Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
            : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while(Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1)+' '+units[u];
    }

    _handleChange(event) {
        const reader = new FileReader()
        const file = event.target.files[0]
        reader.onloadend = (evt) => {
            let blob = new Blob([new Uint8Array(evt.target.result)])
            this.setState({filename: file.name, filetype: file.type, blob: blob, filesize: this.humanFileSize(file.size, true)})
        }
        // 7 MB
        if (file.size < 7000000)
            reader.readAsArrayBuffer(file)

        //HACK: Else, the user won't be able to select the same file in 2 consecutive uploads.
        event.target.value = '';
    }

    removeFile() {
        this.setState({
            filename: '',
            filetype: null,
            blob: null,
            fileIsUploading: false,
            size: 0
        })
    }

    uploadFile(){
        if(!this.state.filename) return;
        const room = this.props.room
        const url = backendApiUrl
        const token = this.props.token
        const routePath = '/v1/room/file/upload_url/get'

        const contentType = this.state.filetype
        const fileName = this.state.filename
        const dataBlob = this.state.blob
        this.setState({
            fileIsUploading: true
        })
        fetch(url + routePath, {
            method: 'POST',
            body: JSON.stringify({
                room: room, content_type: contentType, file_name: fileName
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if(!res.ok) throw res;
            return res.json();
        }).then((res) => {
            const uploadUrl = res.url;
            fetch(uploadUrl, {
                method: 'PUT',
                body: dataBlob,
                headers: {'Content-Type': contentType}
            }).then(res => {
                if(!res.ok) throw res;
            }).then(res => {
                fetch(url+'/v1/room/file/upload_url/done', {
                    method: 'POST',
                    body: JSON.stringify({room: room, file_name: fileName}),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
            }).then(res => {
                this.removeFile()
            })
        })
    }

//=================================================================================

    render() {
        const textColor = this.state.fileIsUploading ? '#898989' : '#333333';
        const backgroundColor = this.state.fileIsUploading ? '#f0f0f0' : '#eaeaea';
        return (
            <div className={style.ChatFooter}>
                <div className={style.TextArea}>
                    {this.state.filename && <div
                        style={{backgroundColor: backgroundColor, color: textColor}}
                        className={style.FileBubble}>
                            {ellipsis(this.state.filename, 15) + ' ' + this.state.filesize}
                            {!this.state.fileIsUploading && <div className={style.CancelButton}> <img onClick={this.removeFile} src='common/assets/images/Close_M.svg' /> </div>}
                    </div>}
                    {this.state.fileIsUploading && <div className={style.Spinner}> <Spinner /> </div>}

                    <textarea
                        color={this.props.color}
                        onInput={this.handleTextareaInput}
                        onKeyup={this.handleTextareaKeyup}
                        onKeypress={this.handleTextareaKeypress}
                        value={this.state.value}
                        class={style.ChatTextarea}
                        style={{height: this.state.filename? '70%':'100%'}}
                        placeholder={this.props.language.get("SendAMessage")}
                        ref={(chatTextareaDOM) => { this.chatTextareaDOM = chatTextareaDOM; }}></textarea>

                </div>
                <div className={style.ChatFooterButtons}>
                    <ChatFooterUploadButton
                        color={this.props.color}
                        onChange={this._handleChange}
                    />
                    <ChatFooterEmojiButton color={this.props.color} />
                    <ChatFooterSendButton color={this.props.color} onClick={this.sendMessage}/>
                </div>
                <EmojiContainer color={this.props.color} addToMessageValue={this.addEmoji}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const room = TicketModel.getCurrentRoom(state)
    const language = CustomizationModel.getLanguage(state)

    return {
        language: language,
        token: state.getIn(['user', 'token']),
        room: room,
        color: state.getIn(['customization', 'color']),
        onlineFormData: state.getIn(['ticket', 'onlineFormData']),
    };
}

export default connect(mapStateToProps, null)(ChatFooter);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/ChatFooter/ChatFooter.js